export class BadRequestError extends Error {
  readonly type: string;
  readonly responseBody?: unknown;
  constructor(responseBody?: unknown) {
    super('Bad request.');
    this.type = 'BadRequestError';
    this.responseBody = responseBody;
  }
}
